import React from 'react';

/**
 * Mobile-only Error State Video Component
 * Shows the "broken state" before Pluckr fixes integration
 * Displays a placeholder until actual video file is provided
 */
const ErrorStateVideo = () => {
  return (
    <div
      className="error-state-video relative overflow-hidden"
      style={{
        aspectRatio: '16/9',
        maxHeight: '400px',
        background: '#000',
        borderRadius: '16px',
        margin: '16px',
        width: 'calc(100% - 32px)',
        boxShadow: '0 0 20px rgba(255, 107, 107, 0.92)', // Orange/coral glow
      }}
      data-testid="error-state-video"
    >
      {/* Video element */}
      <video
        autoPlay
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/Fail.mp4" type="video/mp4" />
      </video>

      {/* Placeholder content - hidden since video file is now provided */}
      <div className="video-placeholder absolute inset-0 flex flex-col items-center justify-center hidden">
        {/* Error icon */}
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="rgba(255, 255, 255, 0.8)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <div className="placeholder-content text-center">
          <span
            className="placeholder-text block text-lg font-medium mb-2"
            style={{ color: 'rgba(255, 255, 255, 0.8)' }}
          >
            Error State Video
          </span>
          <span
            className="placeholder-subtext block text-sm"
            style={{ color: 'rgba(255, 255, 255, 0.6)' }}
          >
            7 sec loop
          </span>
        </div>
      </div>
    </div>
  );
};

export default ErrorStateVideo;
